import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Calendar, Clock, BookOpen, Video, Code } from 'lucide-react';
import { Sec, SH } from '../components/Shared';
import { BLOG_POSTS, LEARNING_PATHS } from '../data/websiteData';

const KnowledgeHubPage = () => {
  const [activePath, setActivePath] = useState(LEARNING_PATHS[0].id);
  const currentPath = LEARNING_PATHS.find(p => p.id === activePath);

  return (
    <div className="af">
      <Sec py={160} bg="var(--grad-hero)">
        <SH eyebrow="Learning System" title="Knowledge Hub" sub="Curated resources, tutorials, and learning paths to accelerate your technical journey." />

        {/* LEARNING PATHS SECTION */}
        <div className="au d1" style={{ marginBottom: 120 }}>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 16, marginBottom: 48, flexWrap: 'wrap' }}>
            {LEARNING_PATHS.map(path => (
              <button
                key={path.id}
                onClick={() => setActivePath(path.id)}
                style={{
                  padding: '12px 24px',
                  borderRadius: 100,
                  background: activePath === path.id ? 'var(--on-surface)' : '#fff',
                  color: activePath === path.id ? '#fff' : 'var(--on-surface-variant)',
                  border: `1px solid ${activePath === path.id ? 'var(--on-surface)' : 'var(--border)'}`,
                  fontSize: 15,
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all .2s'
                }}
              >
                {path.title}
              </button>
            ))}
          </div>

          <div className="card" style={{ padding: 48 }}>
            <div style={{ maxWidth: 640, marginBottom: 40 }}>
              <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 28, fontWeight: 700, color: 'var(--on-surface)', marginBottom: 16 }}>{currentPath.title} Track</h3>
              <p style={{ fontSize: 16, color: 'var(--on-surface-variant)', lineHeight: 1.6 }}>{currentPath.desc}</p>
            </div>

            <div className="g3">
              {currentPath.resources.map((res, i) => (
                <a key={i} href={res.url} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', alignItems: 'center', gap: 16, padding: 24, borderRadius: 12, background: 'var(--surface-container-low)', textDecoration: 'none', transition: 'all .2s' }} onMouseOver={e => e.currentTarget.style.background = 'var(--surface-container-highest)'} onMouseOut={e => e.currentTarget.style.background = 'var(--surface-container-low)'}>
                  <div style={{ width: 48, height: 48, borderRadius: 10, background: '#fff', color: 'var(--primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, boxShadow: 'var(--shadow-sm)' }}>
                    {res.type === 'Video' ? <Video size={20} /> : res.type === 'Tutorial' ? <Code size={20} /> : <BookOpen size={20} />}
                  </div>
                  <div>
                    <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--on-surface)', marginBottom: 4 }}>{res.title}</div>
                    <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--slate-500)', textTransform: 'uppercase', letterSpacing: '.05em' }}>{res.type}</div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* BLOG / TUTORIALS SECTION */}
        <div className="au d2">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 48 }}>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 32, fontWeight: 800, color: 'var(--on-surface)' }}>Latest Tutorials & Insights</h2>
            <Link to="/blog" className="btn btn-ghost hide-m">View All <ChevronRight size={16} /></Link>
          </div>

          <div className="g3">
            {BLOG_POSTS.slice(0, 3).map((post) => (
              <Link key={post.id} to={`/blog/${post.slug}`} className="card" style={{ textDecoration: 'none', display: 'flex', flexDirection: 'column' }}>
                <div style={{ height: 220, overflow: 'hidden', position: 'relative' }}>
                  <img src={post.img} alt={post.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  <div style={{ position: 'absolute', top: 16, left: 16 }}>
                    <span className={`badge ${post.bc}`} style={{ background: '#fff', boxShadow: 'var(--shadow-sm)' }}>{post.cat}</span>
                  </div>
                </div>
                <div style={{ padding: 24, flex: 1, display: 'flex', flexDirection: 'column' }}>
                  <div style={{ display: 'flex', gap: 12, fontSize: 12, color: 'var(--slate-400)', marginBottom: 12, fontWeight: 600 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}><Calendar size={13} /> {post.date}</div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}><Clock size={13} /> {post.read}</div>
                  </div>
                  <h3 style={{ fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 700, color: 'var(--on-surface)', lineHeight: 1.3, marginBottom: 12 }}>{post.title}</h3>
                  <p style={{ fontSize: 14, color: 'var(--on-surface-variant)', lineHeight: 1.6, marginBottom: 20, flex: 1 }}>{post.excerpt}</p>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, fontWeight: 600, color: 'var(--primary)' }}>
                    Read Full Post <ChevronRight size={14} />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </Sec>
    </div>
  );
};

export default KnowledgeHubPage;
